import PropTypes from "prop-types";
import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { Divider } from "antd";
import CheckInInstructions from "./CheckInInstructions";
import CheckInImageCapture from "./CheckInImageCapture";
import DashboardMileageSection, { DEFAULT_FUEL_LEVEL, DEFAULT_MILEAGE } from "./DashboardMileageSection";

const CheckInCaptureSection = forwardRef(({ resetKey = "", flowType = "checkin", t }, ref) => {
    const [walkaroundFiles, setWalkaroundFiles] = useState({});
    const [dashboardFile, setDashboardFile] = useState(null);
    const [fuelLevel, setFuelLevel] = useState(DEFAULT_FUEL_LEVEL);
    const [mileage, setMileage] = useState(DEFAULT_MILEAGE);

    const resetLocalState = () => {
        setWalkaroundFiles({});
        setDashboardFile(null);
        setFuelLevel(DEFAULT_FUEL_LEVEL);
        setMileage(DEFAULT_MILEAGE);
    };

    useEffect(() => {
        resetLocalState();
    }, [resetKey]);

    const getData = () => ({
        walkaroundFiles,
        dashboardFile,
        fuelLevel,
        mileage,
    });

    useImperativeHandle(ref, () => ({
        getData,
    }));

    return (
        <section className="space-y-8">
            <CheckInInstructions t={t} flowType={flowType} />
            <CheckInImageCapture key={resetKey || "checkin-capture"} onImagesChange={setWalkaroundFiles} t={t} />
            <Divider className="my-8" />
            <DashboardMileageSection
                key={resetKey ? `dashboard-${resetKey}` : "checkin-dashboard"}
                onDataChange={(data) => {
                    setDashboardFile(data.dashboardFile);
                    setFuelLevel(data.fuelLevel);
                    setMileage(data.mileage);
                }}
                t={t}
            />
        </section>
    );
});

CheckInCaptureSection.displayName = "CheckInCaptureSection";

CheckInCaptureSection.propTypes = {
    resetKey: PropTypes.string,
    flowType: PropTypes.oneOf(["checkin", "checkout"]),
    t: PropTypes.func.isRequired,
};

export default CheckInCaptureSection;
